import * as api from '@/api'
import * as http from '@/libs/http'

const REASON_UNAUTHORIZED = [
  'ログインに失敗しました。',
  'メールアドレスまたはパスワードをご確認ください。'
]

const REASON_FORBIDDEN = [
  'アカウントが停止されています。',
  'ログインできません。'
]

export default {
  /**
   * ユーザ情報をクリアする
   *
   * @param {Context} context
   * @param {Boolean} force 強制的にクリアする
   */
  clear ({ state, commit, rootGetters }, force = false) {
    // 同じ組織コードならログイン情報をクリアしない
    const orgcode = rootGetters['org/code']
    if (!force && state.orgcode === orgcode) {
      return
    }

    // ステートを一式クリアする
    commit('setData', {})
  },

  /**
   * ログイン認証を行う
   *
   * @param {Context} context
   * @param {*} data ログインデータ
   * @returns {Object} ログインの結果を返す
   */
  async auth ({ commit, rootGetters }, data) {
    // API でログイン認証する
    const orgcode = rootGetters['org/code']
    const resp = await api.auth(orgcode, data)

    // 認証に失敗した
    if (resp.status === http.Unauthorized) {
      return {
        ok: false,
        reason: REASON_UNAUTHORIZED
      }
    }

    // ログイン権限がない
    if (resp.status === http.Forbidden) {
      return {
        ok: false,
        reason: REASON_FORBIDDEN
      }
    }

    // ステートを一式設定する
    commit('setData', { orgcode, ...resp.data })

    return {
      ok: true
    }
  }
}
